import { AssetManagerSingleCardTemplate } from "../../../../templates";
import { ChangePasswordForm } from "../../../shared";

const ChangePassword = (): JSX.Element => {
  return (
    <AssetManagerSingleCardTemplate pageTitle="Change Password">
      <ChangePasswordForm />
    </AssetManagerSingleCardTemplate>
  );
};

export default ChangePassword;
